export default {
  '/': {
    title: 'Unlimited spin to win',
    private: true
  },
  '/profile': {
    title: 'Profile',
    private: true
  },
  '/login': {
    title: 'Sign up',
    private: false
  },
  '/oauthLogin': {
    title: 'Login',
    private: false
  },
  '/install': {
    title: 'Install Unlimited spin to win',
    private: true
  },
  '/terms-of-use': {
    title: 'Terms of use',
    private: false
  },
  '/pricing': {
    title: 'Pricing',
    private: true
  },
  '/template-manager': {
    title: 'Template manager',
    private: true
  },
  '/coupon-histories': {
    title: 'Coupon history',
    private: true
  },
  '/preview': {
    title: 'Preview',
    chromeless: true
  },
  '/displays': {
    title: 'Displays',
    private: true,
    children: [
      {
        id: 'display-rules',
        title: 'Rules',
        regex: '^\/displays.*\/rules$'
      },
      {
        id: 'display-actions',
        title: 'Actions',
        regex: '^\/displays.*\/actions$'
      },
      {
        id: 'display-preview',
        title: 'Preview',
        regex: '^\/displays.*\/preview',
        chromeless: true
      },
      {
        id: 'display-create',
        title: 'Create New Campaign',
        regex: '^\/displays\/create'
      },
      {
        id: 'display-starters',
        title: 'Display starters',
        regex: '^\/displays\/starters'
      },
      {
        id: 'report',
        title: 'Report',
        regex: '^\/displays.*\/report'
      },
      {
        id: 'coupon-histories',
        title: 'Coupon History',
        regex: '^\/displays.*\/coupon-histories'
      },
      {
        id: 'display-edit',
        title: 'Edit display',
        regex: '^\/displays.*$'
      }
    ]
  },

  '/lists': {
    title: 'Lists',
    private: true,
    children: [
      {
        id: 'create-list',
        title: 'Create list',
        regex: '^\/lists\/create$'
      },
      {
        id: 'view-list',
        title: 'View list',
        regex: '^\/lists.*$'
      }
    ]
  },
  '/email-templates': {
    title: 'Email templates',
    private: true,
    children: [
      {
        id: 'create-template',
        title: 'Create template',
        regex: '^\/email-templates\/create$'
      },
      {
        id: 'edit-template',
        title: 'Edit template',
        regex: '^\/email-templates.*$'
      }
    ]
  },
  '/wix/signin': {
    title: 'Login',
    private: false
  },
  '/wix': {
    title: 'Wix',
    private: false,
    children: [
      {
        id: 'pricing',
        title: 'Pricing',
        regex: '^\/wix\/pricing$',
        private: true
      },
      {
        id: 'pricing-public',
        title: 'Pricing',
        regex: '^\/wix\/pricing_public$',
        private: false
      },
      {
        id: 'signin',
        title: 'Sign in',
        regex: '^\/wix\/signin',
        private: true
      },
      {
        id: 'Login',
        title: 'Login',
        regex: '^\/wix\/app'
      }
    ]
  }
}
